import { mapRange, oscillate } from '../util/math'

/* eslint-disable */
export const top = [
  [
    (width, height) => ({
      cx: width / 3,
      cy: 59,
      // change properties based on canvas width
      rotation: mapRange(width, 300, 4000, 3.403, 2.9, true),
      amplitude: 13.067,
      frequency: 3.105,
      // animate phase over time
      phase: (t) => t * 0.0005,
      offset: { x: 0.08, y: 7.6 },
      numWaves: mapRange(width, 300, 4000, 10, 20, true),
      waveRotation: 0.025,
    }),
  ],
  [
    (width, height) => ({
      cx: width - 227.736,
      cy: 121,
      rotation: 3.114,
      amplitude: 20,
      frequency: 3.115,
      phase: 35,
      offset: { x: 2, y: oscillate(10, 20, { duration: 15000 }) },
      numWaves: mapRange(width, 300, 4000, 7, 10, true),
      waveRotation: 0.09,
    }),
  ],
  // [
  //   (width, height) => ({
  //     cx: mapRange(width, 300, 4000, 100, 2000),
  //     cy: 232,
  //     rotation: 2.6987710475899,
  //     amplitude: -11.2,
  //     phase: (t, i) => t * (i % 2 === 0 ? -0.0005 : 0.0005),
  //     frequency: 3.17,
  //     offset: { x: 2.1, y: 33 },
  //     numWaves: 11,
  //     waveRotation: 0.0523017644881764,
  //   }),
  // ],
  [
    () => ({
      cx: 79,
      cy: 145,
      rotation: 2.72666532198359,
      amplitude: 20,
      phase: 0,
      frequency: 3.12,
      offset: {
        x: 0,
        y: oscillate(0, 40, { duration: 30000 }),
      },
      numWaves: 10,
      waveRotation: 0.0662489016850234,
    }),
  ],
]

export const bottom = [
  [
    (width, height) => ({
      cx: 250,
      cy: height - 150,
      rotation: 3,
      amplitude: -7.95,
      frequency: 3.164,
      offset: { x: 2.124, y: 10 },
      numWaves: 10,
      waveRotation: 0.098,
    }),
  ],
  [
    (width, height) => ({
      cx: 321.802,
      cy: height - 140.494,
      rotation: 3.1,
      amplitude: 20,
      frequency: 3.125,
      offset: { x: 2.186, y: 10 },
      numWaves: 10,
      waveRotation: 0.051,
    }),
  ],
  [
    (width, height) => ({
      cx: width - 150,
      cy: height - 200,
      rotation: 2.08509701092863,
      amplitude: 6.2,
      phase: 48.3,
      frequency: 3.21,
      offset: { x: 0, y: 0 },
      numWaves: 15,
      waveRotation: 0.0662489016850234,
    }),
  ],
]
/* eslint-enable */
